import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button, TERTIARY } from '@glu/buttons-react';

import useLocale from 'components/useLocale';

import useStyles from './widgetMenu.styles';

const KEYS = {
  ESCAPE: 'Escape'
};

export const WidgetMenuComponent = ({
  id,
  menuToggleRef,
  onClose,
  onRemoveClick,
  onResizeClick,
  open,
  showRemove,
  showResize,
  widgetId
}) => {
  const locale = useLocale();
  const { menu, menuButton } = useStyles();

  const closeOnOutside = (e) => {
    if (menuToggleRef.current && open && !menuToggleRef.current.contains(e.target)) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === KEYS.ESCAPE) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeOnOutside);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('focusin', closeOnOutside);
    return () => {
      document.removeEventListener('mousedown', closeOnOutside);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('focusin', closeOnOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id={`widgetMenu-${widgetId}`} data-qa={`widgetMenuPanel-${widgetId}`} className={menu}>
      {showRemove && (
        <Button
          dataQa="widget-remove"
          type="button"
          id="remove"
          className={menuButton}
          onClick={() => onRemoveClick(id)}
          variant={TERTIARY}
        >
          {locale['common.remove']}
        </Button>
      )}
      {showResize && (
        <Button
          dataQa="widget-resize"
          type="button"
          id="resize"
          className={menuButton}
          onClick={() => onResizeClick(id)}
          variant={TERTIARY}
        >
          {locale['common.resize']}
        </Button>
      )}
    </div>
  );
};

WidgetMenuComponent.defaultProps = {
  id: '',
  showResize: true,
  showRemove: true
};

WidgetMenuComponent.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onResizeClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  showResize: PropTypes.bool,
  showRemove: PropTypes.bool,
  widgetId: PropTypes.string.isRequired,
  menuToggleRef: PropTypes.objectOf({ current: PropTypes.node }).isRequired
};

export default WidgetMenuComponent;
